import { citizenshipConfig } from '../config';

export const getMatchingCountries = (
  query: string,
  _locale: unknown,
  countryCodes?: string[],
) => {
  const trimmed = query.trim();

  const list = countryCodes
    ? citizenshipConfig.countryList.filter(country =>
        countryCodes.includes(country.code),
      )
    : citizenshipConfig.countryList;

  if (!trimmed) {
    return citizenshipConfig.countryList;
  }

  const lower = trimmed.toLocaleLowerCase();

  return list.filter(({ name, nameKK, nameEN, code }) => {
    return (
      name.toLocaleLowerCase().includes(lower) ||
      nameKK.toLocaleLowerCase().includes(lower) ||
      nameEN.toLocaleLowerCase().includes(lower) ||
      code.toLocaleLowerCase().includes(lower)
    );
  });
};
